module.exports = __webpack_public_path__ + "static/GPlogoWhiteBG2-36057c339c83555a575dac8b53a43f7a.png";